module.exports = __webpack_public_path__ + "static/img/programmebg1.cd243b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/programme/programmebg1.png
// module id = tnfd
// module chunks = 1